var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['far', 'face-frown'],"size":"5x"}}),_c('h1',[_vm._v(_vm._s(_vm.labels.code))]),_c('p',[_vm._v(_vm._s(_vm.labels.title))]),_c('router-link',{staticClass:"btn-home",attrs:{"to":{ name: 'home' }}},[_vm._v(_vm._s(_vm.labels.goToHome))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }